import { UserAuthProvider } from '../user-auth-provider';

import { OktaAuth } from '@okta/okta-auth-js';

export class OktaAuthProvider extends UserAuthProvider {
  private auth: OktaAuth;

  constructor(config: {
    redirectUri: string;
    audience: string;
    clientId: string;
    apiToken: string;
    scope: string[];
    groupId: string;
    pkce: boolean;
    history: null;
    url: string;
    issuer: string;
    devMode: boolean;
  }) {
    config.pkce = OktaAuth.features.isPKCESupported();
    super(config);

    this.auth = new OktaAuth(config);
  }

  public getUser() {
    return this.auth.getUser();
  }

  public async isAuthenticated() {
    const isAuthed = await this.auth.isAuthenticated();

    return isAuthed;
  }

  public async redirect(params: any) {
    this.auth.signInWithRedirect(params);

    // tslint:disable-next-line:no-empty
    return new Promise((resolve, reject) => {});
  }

  public isInLoginRedirect(): boolean {
    return this.auth.isLoginRedirect();
  }

  // Fetch the PKCE tokens off the URL and throw them in the token manager
  // Looking for redirects? They're not down down here. Look in AuthStore and the AuthCallback component
  public storeAuthTokensFromCallback() {
    return this.auth.storeTokensFromRedirect();
  }

  public closeSession() {
    return this.auth.closeSession();
  }

  public signIn(params: { password: string; username: string }) {
    return this.auth.signInWithCredentials(params);
  }

  public signInWithToken(token: string) {
    return this.auth.signIn({ token });
  }

  public async getAccessToken() {
    return await this.auth.getAccessToken();
  }

  public async getIdToken() {
    return await this.auth.getIdToken();
  }

  public logout(path: string) {
    return this.auth.signOut();
  }
}
